import React from 'react';

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  confirming = false,
  onConfirm,
  onCancel,
}) {
  if (!open) {
    return null;
  }

  return (
    <div className="patent-dialog__backdrop" role="presentation">
      <div
        className="patent-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="patent-confirm-dialog-title"
      >
        <h2 id="patent-confirm-dialog-title" className="patent-dialog__title">
          {title}
        </h2>
        <p className="patent-dialog__message">{message}</p>
        <div className="patent-dialog__actions">
          <button
            className="patent-entry__ghost"
            type="button"
            onClick={onCancel}
            disabled={confirming}
          >
            {cancelLabel}
          </button>
          <button
            className="patent-entry__submit patent-entry__submit--danger"
            type="button"
            onClick={onConfirm}
            disabled={confirming}
          >
            {confirming ? 'Deleting…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
